window.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('body:not(.neos-backend) .c-gallery').forEach(initGallery);
});
function initGallery(gallery) {
  if (!gallery) return;
  const triggers = gallery.querySelectorAll('.lightbox-trigger');
  const modal = gallery.querySelector('.lightbox-modal');
  const modalImg = gallery.querySelector('.lightbox-image');
  const copyright = gallery.querySelector('.lightbox-copyright');
  const caption = gallery.querySelector('.lightbox-caption');
  const closeBtn = gallery.querySelector('.icon-times');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const data = trigger.querySelector('.c-image');
      if (!data) return;
      if (modalImg && copyright && caption) {
        modalImg.src = data.dataset.src;
        modalImg.alt = data.dataset.alt;
        const copyrightText = data.dataset.copyright;
        if (copyrightText !== '') {
          copyright.innerHTML = copyrightText;
          copyright.classList.remove('hidden');
        } else {
          copyright.classList.add('hidden');
        }
        const captionText = data.dataset.caption;
        if (captionText !== '') {
          caption.innerHTML = captionText;
          caption.classList.remove('hidden');
        } else {
          caption.classList.add('hidden');
        }
      }
      modal.showModal();
    });
  });
  closeBtn.onclick = function () {
    modal.close();
  };
}